<div class='table-wrapper'>
	<div class='gia-share-section'>
		<a target='_blank' class="gia-share twitter" href="https://twitter.com/intent/tweet?text=Want to fix gun violence in America%3F Go local&amp;url=https://www.theguardian.com/us-news/ng-interactive/2017/jan/09/special-report-fixing-gun-violence-in-america?CMP=share_btn_tw&via=GuardianUS">&nbsp;t</a>
		<a class='gia-share facebook' target='_blank' href='https://www.facebook.com/dialog/share?app_id=180444840287&href=https://www.theguardian.com/us-news/ng-interactive/2017/jan/09/special-report-fixing-gun-violence-in-america&redirect_uri=https://www.theguardian.com/us-news/ng-interactive/2017/jan/09/special-report-fixing-gun-violence-in-america'>&nbsp;f</a>
	</div>

<!-- <StLouis /> -->
	<h1>Want to fix gun violence in America? Go local.</h1>
	<div class='gia-byline'>By Aliza Aufrichtig, Lois Beckett, Jan Diehm and Jamiles Lartey</div>


		<UsaJan mapNum={{1}} />
	<div class='gia-intro'>

		<p><span class='gia-drop-cap'>T</span>he map of America’s gun violence epidemic can seem overwhelming. There were more than 13,000 gun homicides in the US in 2015, across nearly 3,500 cities and towns. But the toll of this gun violence was not distributed equally.</p>

		<p>Half of America's gun homicides in 2015 were clustered in just 127 cities and towns, according to a new geographic analysis by the Guardian, even though they contain less than a quarter of the nation’s population.</p>
</div>
	<PairUsa />


<div class='gia-intro big-margin-below'>

	<p>Even within those cities, violence is further concentrated in the tiny neighborhood areas that saw two or more gun homicide incidents in a single year.  </p>

	<p>Four and a half million Americans live in  areas of these cities with the highest numbers of gun homicide, which are marked by intense poverty, low levels of education, and racial segregation. Geographically, these neighborhood areas are small: a total of about 1,200 neighborhood census tracts, which, laid side by side, would fit into an area just 42 miles wide by 42 miles long. </p>

	<p>The problem they face is devastating. Though these neighborhood areas contain just 1.5% of the country’s population, they saw 26% of America’s total gun homicides.</p>

	<p>Gun control advocates say it is unacceptable that Americans overall are "<a target='_blank' href='http://everytown.org/learn/'>25 times more likely</a> to be murdered with a gun than people in <a target='_blank' href='http://www.amjmed.com/article/S0002-9343(15)01030-X/fulltext'>other developed countries</a>". People who live in these neighborhood areas face an average gun homicide rate about 400 times higher than the rate across those high-income countries. </p>

	<p>Understanding this dramatic clustering of America’s of gun violence is crucial for the effort to save more lives. </p>

	<p>“We can’t do much about crime prevention of homicide if we try to attack it as a broad, global problem, throwing money at it in a sort of broad, global way,” said David Weisburd, a leading researcher on the geographic distribution of crime at George Mason University. </p>

	<p>America’s gun policy debate is usually driven by high-profile mass shootings that seem to strike at random, and it focuses on sweeping federal gun control or mental health policies. But much of America’s gun homicide problem happens in a relatively small number of predictable places, often driven by predictable groups of high-risk people, and its burden is anything but random. </p>

	<p>The concentration of gun homicides in certain census tracts mirrors what criminologists have discovered when they look at crime patterns within individual cities: roughly 1.5% of street segments in cities see about 25% of crime incidents, a trend dubbed “<a target='_blank' href='http://onlinelibrary.wiley.com/doi/10.1111/1745-9125.12070/abstract'>the law of crime concentration</a>”. </p>

	<p>The Guardian’s new geographic analysis is the first time that gun homicides nationwide have been mapped down to the census tract level, researchers said. This new approach was made possible with the geocoded data <a target='_blank' href='https://www.theguardian.com/world/2016/apr/23/kentucky-gun-owner-gun-violence-archive-mark-bryant'>collected since 2014</a> by the not-for-profit <a target='_blank' href='http://www.gunviolencearchive.org/'>Gun Violence Archive</a>, which tracks shootings and gun deaths using media reports. The FBI’s national crime data only provides gun murder statistics down to the city level, which masks the clustering of violence within neighborhoods.</p>



</div>
<Scroller />
<div class='gia-intro big-margin-above'>

	<p>The clear dividing line you see between areas with many gun homicides and few gun homicides is Delmar Boulevard, which has developed over time into a rigid racial boundary that carves the city in two.</p>

	<div class='update-for-day-two clearfix'>

		<img class='st-louis-image' src='<@baseUrl@>/<@version@>/files/images/abandoned-lot.jpg' />
		<div class='inside-day-two'><a href='https://www.theguardian.com/world/ng-interactive/2017/jan/10/st-louis-gun-crime-missouri-natural-bridge-avenue'>Read more dispatches from St Louis, north of Delmar Boulevard »
			<!-- <img class='chevron' src='<@baseUrl@>/<@version@>/files/icons/chevron.svg' /> -->

		</a></div>


	</div>

	<p class='little-margin-above'>For the greater part of the 20th century, racial housing covenants, discriminatory lending practices and “white flight” imposed de facto segregation as pronounced as any ever achieved by Jim Crow on St Louis’ black residents. Even today, some residents treat Delmar Boulevard as a line they do not want to cross. In May, a group of parents <a target='_blank' href='http://www.stltoday.com/news/local/columns/tony-messenger/messenger-canceled-ballgame-teaches--year-olds-about-delmar-divide/article_d7e51a76-3476-5156-a5b7-cab3c4f88186.html'>canceled a kindergarten Little League game</a> held in a park north of Delmar Boulevard, telling the opposing team that they were “uncomfortable with the location” of their home field, a decision a home team parent called “racist”. </p>


</div>
<h2 class='gia-subhead'>Like income inequality, murder inequality in America is stark</h2>
<div class='gia-intro'>


	<p>Gun violence is a regressive tax that falls heaviest on neighborhoods already struggling with poverty, unemployment, and failing schools. The unequal burden of violence is also marked by intense racial disparities. </p>

	<p>“It’s not about race, per se, it’s about how other conditions are racialized, are racially inequitable,” said Lauren Krivo, a Rutgers University sociologist who studies the geography of race and crime.</p>

	<p>Most people don’t understand “how few predominantly white communities have conditions that are anywhere near the levels of disadvantage that are common in non-white communities, and particularly black communities,” she said.</p>
</div>
<MiniMaps />
<h2 class='gia-subhead'>Dramatic racial disparities in homicide have persisted for decades</h2>
<div class='gia-intro'>
<p>Within most high-gun homicide cities, victims of gun murder are overwhelmingly black men. This dramatic disparity has persisted for decades, even as cities have seen sharp increases and decreases in murder rates, according to FBI gun murder data. These charts break down the numbers of gun murders since 1975 by race and gender for different cities.</p>
	</div>

	<LineCharts />
<div class='gia-intro'>

	<p>Since 1993, the peak of the gun violence epidemic of the late 1980s and early 1990s, the nation’s overall gun homicide rate has fallen <a target='_blank' href='http://www.pewsocialtrends.org/2013/05/07/gun-homicide-rate-down-49-since-1993-peak-public-unaware/'>nearly 50%</a>, according to national estimates from the Centers for Disease Control and Prevention (CDC). Overall, the country is much safer than in the 1990s, though polls show most Americans <a target='_blank' href='http://www.pewsocialtrends.org/2013/05/07/gun-homicide-rate-down-49-since-1993-peak-public-unaware/'>remain unaware</a> of that trend.  For African Americans, too, the overall gun homicide rate fell by <a target='_blank' href='https://www.bjs.gov/content/pub/pdf/fv9311.pdf'>about half</a> between 1993 and 2010, according to national CDC estimates. </p>

	<p>Examining gun murder trends across individual cities, and going back to 1975, shows a more complex picture. New York City has become radically safer for all residents since the early 1990s, and continues to see decreases in violence. In other cities, including St Louis and Baltimore, the number of black men murdered with guns in recent years is close to the early 1990s. </p>

</div>
<h2 class='gia-subhead'>Not just neighborhoods but people</h2>

<div class='gia-intro'>

	<p>Looking at the risk of gun homicide in terms of sweeping racial demographics, or even in terms of individual neighborhood census tracts, still obscures the real concentration of violence, crime experts said  – and that further concentration is crucial to understanding how to save lives. </p>

<p>Even within high-poverty areas that struggle with many kinds of disadvantage, the majority of residents have nothing to do with gun violence. </p>

<p>Within neighborhood areas, the risk of violence is further clustered within specific social networks of high-risk people. Sometimes these are people whom police identify as gang members; sometimes they are not. </p>

<p>In Chicago, <a target='_blank' href='http://www.hoplofobia.info/wp-content/uploads/2014/05/Tragic-but-not-Random-The-Social-Contagion-of-nonfatal-gunshot-injuries.pdf'>analysts</a> working with police department data found that, over a six-year period, 70% of nonfatal shootings and 46% of gun homicides happened within a sprawling social network that included just 6% of Chicago’s total population. </p>

<p>Similar analyses in <a target='_blank' href='https://www.propublica.org/article/how-the-gun-control-debate-ignores-black-lives'>Oakland</a> and <a target='_blank' href='https://nnscommunities.org/uploads/Corsaro_Engel_NOLA_Evaluation_The_Most_Challenging_of_Contexts_CPP_2015.pdf'>New Orleans</a> found even smaller percentages of residents driving the majority of the violence. In Oakland, analysts found that networks of just 1,000 to 1,200 high-risk people, about .3% of Oakland’s population, were involved in about 60% of the city’s murders. In New Orleans, just 600 to 700 people, less than 1% of the city’s population, were involved in more than 50% of fatal incidents. </p>

<p>“In what we think of as the ‘most dangerous places’, very, very few people are actually at any meaningful risk for violent offending,” said David Kennedy, a researcher and advocate at the John Jay College of Criminal Justice who has worked on violence prevention strategies in cities nationwide. “Most of the folks in those places are in no way a part of the problem.” </p>

<p>Both liberals and conservatives argue that the root causes of gun violence are extremely broad social trends. For conservatives, it’s “about things like cultures of violence, toxic family dynamics in minority communities, the failure of governmental approaches”, Kennedy said. For liberals, it’s historic oppression, racism, lack of opportunity, and the broad availability of guns. </p>

<p>As a result, both liberals and conservatives argue that fixing violence requires interventions that are “very enormous and very often essentially out of reach”, Kennedy said. “We’re talking about making changes that, as a practical matter, we’re not very good at: changing, in a broad way, gender in society, changing, in a broad way, social patterns or racism or bias. Fixing the schools. That’s very difficult stuff.” </p>

<p>But neither partisan analysis really lined up with the data on America’s murder concentration, Kennedy said. If single parent families, or poverty, or easy gun availability were the main drivers of gun violence, “that should result in vastly more violence that there is”. </p>

<p>Instead, some researchers argue, the concentration of gun violence in America more closely resembles the spread of a contagious disease. Inequity and poverty are risk factors. But violence itself may spread from person to person like a virus, meaning that particular networks of people, not whole neighborhoods or demographic groups, are most at risk. </p>

<p>In different times and places, violence in America has spread like a wave through different ethnic and racial groups, said Dr Gary Slutkin, a Chicago epidemiologist who has championed a public health model for preventing violence. In the 1920s, violence was concentrated among Irish American and Italian American populations, he said. In recent decades, it’s been more concentrated among African Americans. “There is nothing innate,” he said. “All people and peoples are susceptible.” </p>

<p>The racial and geographic disparities in America’s gun homicide problem are clear. They are also often overstated, both by some political opponents of gun control and by white supremacists.  </p>

<p>One false meme that spread online after Trayvon Martin’s death said: “The United States ranks 3rd in Murders throughout the World. But if you take out Chicago, Detroit, Washington DC and New Orleans, the United States is 4th from the Bottom for Murders. These 4 Cities also have the toughest Gun Control Laws in the United States. All 4 are also controlled by Democrats.” </p>

<p>These murder numbers are completely inaccurate – and so is the broader concept behind them. </p>

<p>While half of America’s gun homicides were clustered in 127 cities, the other half were spread across the country. In many of the roughly 3,300 other cities that saw a gun homicide in 2015, the violence was less intense. 58% of cities that saw a gun homicide in 2015 saw just a single one, and 95% of them saw fewer than ten. </p>

<p>The toll of these more scattered gun homicides adds up. Even excluding the 127 highest homicide cities, America’s gun homicide rate would still be many times higher than recent rates in Europe. </p>

<p>While violence in Chicago perpetually makes headlines, some of the census tracts with the greatest burden of violence are at the margins of cities that are not known for their gun homicide problem – islands of extreme deprivation in otherwise wealthy, placid towns. </p>

<p>Donald Trump has spent months decrying the historic spike in gun violence in Chicago, most recently suggesting on Twitter that if Chicago’s “Mayor can't do it he must ask for Federal help!” </p>

<p>Seventeen minutes from Mar-a-Lago, Trump’s flagship Palm Beach hotel, is a neighborhood with one of the highest gun homicide rates in the country. </p>

<p>Kiki Paulk lives just miles from where Trump and his transition team vacationed this holiday. About every third night, the 31-year-old West Palm Beach resident said, she has to get her children down on the floor to protect them from the gunfire. </p>

<p>The Tamarind Avenue area’s gun murder rate in 2015 was double or triple that of some of the most violent areas in Chicago.</p>

<p> Asked who was working to stop the violence in her neighborhood, Paulk said, “No –  no –  no – there’s nobody.” </p>


	<p class='gia-sources'>Sources: Gun Violence Archive 2015, excluding accidental gun deaths and suicides, but including justifiable homicides, by law enforcement and others; FBI Supplementary Homicide Reports 1975 - 2015; FBI Uniform Crime Report 2015; 5-Year American Community Survey 2014-2010; US Census: Cartographic Boundary Shapefiles - Census Tracts; CDC’s National Center for Injury Prevention and Control Web-based Injury Statistics Query and Reporting System (WISQARS); Gunpolicy.org. In maps, "Percent without high school degree" refers to percent of residents age 25 or older without a high school degree.
</p>
</div>
</div>
<style>

.st-louis-image {
	/*float: left;*/
	height: 100px;
	/*margin-bottom: 30px;*/
	display: none;
}

.chevron {
	height: 24px;
	-webkit-transform: rotate(270deg);
	-moz-transform: rotate(270deg);
	-o-transform: rotate(270deg);
	-ms-transform: rotate(270deg);
	transform: rotate(270deg);
	/*float: right;*/
	margin-left: 15px;
}

.update-for-day-two {
	border-top: 1px solid #dbdbdb;
	border-bottom: 1px solid #dbdbdb;
	max-width: 620px;
	margin: 0 auto;
	padding: 20px 0 20px 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	align-content: center;

}

.gia-sources {
	max-width: 620px;
	margin: 30px auto 0;
	padding-top: 8px;
	border-top: 1px solid #dbdbdb;
	color: #989898;
	font-family: 'Guardian Text Sans Web',Helvetica,Arial,sans-serif;
	font-size: 14px;
}
h2 {
max-width: 620px;
margin: 0 auto;
font-family: 'Guardian Egyptian Web';
font-size: 28px;
line-height: 1.2;
}

.gia-drop-cap {
		float: left;
    color: #c05303;
    font-size: 72px;
    line-height: 60px;
    padding-top: 4px;
    padding-right: 8px;
    padding-left: 3px;
	}

.big-margin-above {
	margin-top: 50px;
}

.big-margin-below {
	margin-bottom: 50px;
}

.gia-subhead {
	margin-bottom: 20px;
}

.table-wrapper {
	width: 100%;
	max-width: 1180px;
	margin: 0 auto;
	padding: 10px;
	box-sizing: border-box;
	background: white;
}
/*.table-wrapper img {
		display: block;
		width: 175px;
		margin: 0 auto 2em;
}*/
.gia-intro {
	max-width: 620px;
	margin: 0 auto;
	width: 100%;
	margin-bottom: 2.5em;
}

.gia-intro p {


	max-width: 620px;
		margin: 0 auto;
		margin-bottom: 1.2em;

}
.gia-key {
	width:100%;
	text-align: right;
	color: #989898;
	float:right;
	font-family: 'Guardian Text Sans Web';
	font-size: 12px;
}
.bar-outer {
	width: 100px;
	background-color: #eaeaea;
	height: 18px;
}
.bar-inner {
	height: 100%;
	position: relative;
}
.bar-inner span {
		font-size: 15px;
		font-family: 'Guardian Text Sans Web';
		font-color: white;
		position: absolute;
		top: 0px;
		right: 5px;
		color: white;
}

.table-wrapper h1 {
	font-size: 32px;
	line-height: 1.2;
	margin-top: .5em;
	font-family: 'Guardian Egyptian Web';
		font-weight: 800;
}

.gia-section {
	margin: 0 auto 3em;
}
.gia-byline {
	font-size: 16px;
	font-family: 'Guardian Text Sans Web';
	color: #989898;
	margin: .75em 0 2.5em;
	line-height: 1.2;
}
.gia-description {
	font-family: 'Guardian Egyptian Web';
	font-weight: 800;
	font-size: 24px;
	line-height: 1.4;
	margin: 0 0 10px 0;
	padding-top: 5px;
	border-top: 2px solid #eaeaea;
	line-height: 1.4;
}
.gia-how {
	font-family: 'Guardian Text Egyptian Web';
	font-size: 16px;
	margin: 0 0 1.2em 0;
}
.gia-how span {
	font-family: 'Guardian Egyptian Web';
	font-weight: 800;
}
.approval {
	float: left;
	font-family: 'Guardian Text Sans Web';
	font-size: 16px;
	float:right;
}
.approval.na {
	color: #333;
}
.gia-strap {
	text-transform: uppercase;
	font-family: 'Guardian Text Sans Web';
	font-size: 14px;
	font-weight: 800;
}

.gia-share-section {
	text-align: right;
	width: 100%;
}
.gia-share {
	display: inline-block;
	width: 30px;
	height: 30px;
	background: center no-repeat #989898;
	background-size: 50%;
	border-radius: 50%;
	margin: 0;
	cursor: pointer;
	top: -4px;
	position: relative;
	color: transparent;
}
.gia-share.facebook {
	background-image: url('<@baseUrl@>/<@version@>/files/images/facebook.svg');
	background-size: 25%;
}
.gia-share.twitter {
	background-image: url('<@baseUrl@>/<@version@>/files/images/twitter.svg');
}

.clearfix:after {
   content: ".";
   visibility: hidden;
   display: block;
   height: 0;
   clear: both;
}


.inside-day-two {
	/*float: left;*/
	/*margin-bottom: 0px;*/
	font-weight: 900;

	/*padding-top: 15px;*/
}



@media (min-width: 380px) {
	.table-wrapper h1 {
		font-size: 32px;
		line-height: 1.2;
	}
	.gia-byline {
		font-size: 18px;
	}

	/*.table-wrapper {
		padding: 0;
	}*/
	.table-wrapper h1 {
		font-size: 46px;
	}
	.bar-outer {
		width: 120px;
	}
	.gia-strap {
		font-size: 16px;
	}
	.gia-description {
		font-size: 28px;
	}

	.st-louis-image {
		/*float: left;*/
		height: 100px;
		/*margin-bottom: 30px;*/
		display: block;
	}

	.inside-day-two {
		max-width: calc(100% - 224px);
		/*width: 400px;*/
		padding-left: 30px;
	}
}
@media (min-width: 620px) {
	.gia-byline,
	.table-wrapper h1 {
		text-align: center;
		max-width: 740px;
		margin: .5em auto;
	}

	.table-wrapper h1 {
		font-size: 48px;
	}
	.gia-byline {
		margin: .75em auto 2.5em;
	}
}


.little-margin-above {
	padding-top: 20px;
}
</style>

<script>

import StLouis from './components/StLouis.html';
import UsaJan from './components/UsaJan.html';
import LineCharts from './components/LineCharts.html';
import MiniMaps from './components/MiniMaps.html';
import Scroller from './components/Scroller.html';
import PairUsa from './components/PairUsa.html';


	export default {
		data () {
		 return {
		 }
	 },

	 components: {
		 StLouis,
		 UsaJan,
		 LineCharts,
		 MiniMaps,
		 Scroller,
		 PairUsa
	 }

	};
</script>
